module.exports = __webpack_public_path__ + "media/images/patient-icons/arrow-down-1cd7612393cb6171bea78075cb529a02.svg";